





















































































































































































import { Vue } from 'vue-property-decorator'
import {
  StockOutPlanMaterialServiceProxy,
  StockOutPlanServiceProxy
} from '@/service-proxies/app-v2/wms.service-proxies'
import {
  WarehouseAreaServiceProxy,
  WarehouseLocationServiceProxy,
  WarehouseMaterialStockServiceProxy
} from '@/service-proxies/app-v2/warehouse.service-proxies'
import dayjs from 'dayjs'
import { EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies'
const wmssp = new WarehouseMaterialStockServiceProxy()
const wlsp = new WarehouseLocationServiceProxy()
const wasp = new WarehouseAreaServiceProxy()
const sopmsp = new StockOutPlanMaterialServiceProxy()
const sopsp = new StockOutPlanServiceProxy()
const esp = new EmployeeServiceProxy()

const columns = [
  {
    title: 'page_business_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_check_area',
    dataIndex: 'areaId',
    scopedSlots: { customRender: 'areaId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_check_location',
    dataIndex: 'locationId',
    scopedSlots: { customRender: 'locationId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_check_locationnum',
    dataIndex: 'stockNum',
    scopedSlots: { customRender: 'stockNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_delivery_plan_current_issue_quantity',
    dataIndex: 'stockOutNum',
    scopedSlots: { customRender: 'stockOutNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_delivery_plan_issued_quantity',
    dataIndex: 'deliveredNum',
    scopedSlots: { customRender: 'deliveredNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_quantity_be_issued',
    dataIndex: 'toBeDeliveredNum',
    scopedSlots: { customRender: 'toBeDeliveredNum' },
    ellipsis: true,
    width: 150
  }
]
export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      dataSource: [],
      materialList: [], // 库位列表
      loading: false,
      count: 0,
      areaList: [],
      locationList: [],
      selectedRowKeys: [],
      employeesList: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deliveryDetail: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          const obj: any = { statusList: [1] }
          esp.getPageEmployees(1, obj, '', 999999).then((res) => {
            this.employeesList = res.records
          })
          this.dataSource = []
          this.getList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    async getAreaList(value, bol) {
      if (bol) {
        const res = await wasp.listWarehouseArea(value)
        this.areaList = res
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getOut(record) {
      console.log(record.id)
      let bol = false
      bol = this.selectedRowKeys.indexOf(record.id) !== -1
      return bol
    },
    handleChangeArea(value, record) {
      const newData = [...this.dataSource]
      const target = newData.find((item) => record.key === item.key)
      const area = this.areaList.find((res) => res.id === value)
      if (target && area) {
        target['areaId'] = area.id
        target['areaName'] = area.name
        this.dataSource = newData
      }
    },
    async getLocationList(value, record, bol) {
      if (bol) {
        const res = await wlsp.listWarehouseLocationByMaterial(
          record.areaId,
          value,
          record.materialId
        )
        this.locationList = res
      }
    },
    async handleChangeLocation(value, record) {
      const newData = [...this.dataSource]
      const target = newData.find((item) => record.key === item.key)
      const location = this.locationList.find((res) => res.id === value)
      if (target && location) {
        target['locationId'] = location.id
        target['locationName'] = location.warehouseLocationName
        const materialI = await wmssp.listWarehouseMaterialStock(location.id, record.materialId)
        target['stockNum'] = materialI[0].locationNum
        target['stockOutNum'] = 0
        this.dataSource = newData
      }
    },
    dayjsTime(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    async getList() {
      const res = await sopmsp.listStockOutPlanMaterial(this.deliveryDetail.id)
      this.dataSource = res.map((item, index) => {
        let dat = { ...item }
        dat['key'] = index + 'edit'
        return dat
      })
    },
    handleChange(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      if (target) {
        target[column] = value
        this.dataSource = newData
      }
    },
    close() {
      this.form.resetFields()
      this.dataSource = []
      this.selectedRowKeys = []
      this.employeesList = []
      this.$emit('close')
    },
    save() {
      const list = this.dataSource.filter(
        (res) => res.areaId && res.locationId && this.selectedRowKeys.indexOf(res.id) != -1
      )
      if (list.length === 0) {
        this.$message.warning(this.$t('page_material_delivery_plan_enter_required_item'))
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          const data: any = {
            planCode: this.deliveryDetail.planCode,
            planId: this.deliveryDetail.planId,
            stockOutPlanCode: this.deliveryDetail.code,
            stockOutPlanId: this.deliveryDetail.id,
            stockOutUserId: values.stockOutUserId,
            pickingUserId: values.pickingUserId,
            list: list
          }
          this.loading = true
          sopsp
            .stockOut(data)
            .then(() => {
              this.close()
              this.loading = false
            })
            .catch(() => {
              console.log(55442)
              this.loading = false
            })
        }
      })
    }
  }
})
